import {Component, OnInit, Input} from '@angular/core';

@Component({
  selector: 'hir-program-card',
  templateUrl: './hir-program-card.component.html',
  styleUrls: ['./hir-program-card.component.scss']
})

export class HirProgramCardComponent implements OnInit {
  @Input ('url') programUrl: string;
  @Input('title') programName: string;
  @Input('description') programIconClass: string;
  @Input('visible') programAccessible: boolean;
  
  constructor() { }

  ngOnInit() { }

  isProgramAccessible(): boolean {
    return this.programAccessible;
  }

  isLegacyUrl(url) {
    return url.includes('.jsp');
  }
}
